module.exports = require("./src/constants");